// VendedoresMinoristas/CrearMinorista.jsx
export default function CrearMinorista() {
  return <div>Vista: Crear Minorista</div>;
}
